import { clsx } from 'clsx'

import styles from './workspace-settings.module.scss'
import { PureSwitcher } from '../../../../../common/ui/pure-switcher/pure-switcher'
import { WorkspaceTableMode, WorkspaceWorkMode } from '../../constants/workspace.constants'
import { WorkspaceConfiguration } from '../../types/wrokspace.types'

export type WorkspaceSettingsProps = {
  onChange: (settings: Partial<WorkspaceConfiguration>) => void
  init: WorkspaceConfiguration
}

export const WorkspaceSettings = ({ onChange, init }: WorkspaceSettingsProps) => {
  const handleTableModeChange = (value: boolean) => {
    const config = value ? { tableMode: WorkspaceTableMode.Full } : { tableMode: WorkspaceTableMode.Dates }
    onChange(config)
  }

  const handleWorkModeChange = (value: boolean) => {
    const config = value ? { workMode: WorkspaceWorkMode.Checking } : { workMode: WorkspaceWorkMode.Filling }
    onChange(config)
  }

  return (
    <div className={clsx(styles.settingsWrapper, 'd-flex', 'justify-content-between')}>
      <div>
        <h5>Режим таблицы</h5>
        <PureSwitcher
          className="w-100 d-flex justify-content-between"
          isChecked={init.tableMode === WorkspaceTableMode.Full}
          label={['Полный', 'Только даты']}
          onChange={handleTableModeChange}
        />
      </div>
      <div>
        <h5>Режим майлстоунов</h5>
        <PureSwitcher
          className="w-100 d-flex justify-content-between"
          isChecked={init.workMode === WorkspaceWorkMode.Checking}
          label={['Проверка', 'Заполнение']}
          onChange={handleWorkModeChange}
        />
      </div>
    </div>
  )
}
